<!-- #15 -->
<template>
  <v-col cols="12" md="4" sm="6" xs="12" class="ma-4 mx-auto">
    <v-card class="elevation-2">
      <v-toolbar color="primary" dark flat>
        <v-toolbar-title class
          >Change Password
          <i class="caption red--text ml-4">
            * required field</i
          ></v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-icon>mdi-lock</v-icon>
      </v-toolbar>
      <h5 class="subheader">
        Your new password must satsify mentioned criteria
      </h5>
      <v-list class="list-custom">
        <v-list-item v-for="(check, index) in passwordChecks" :key="index">
          <div class="bg-color">
            <v-icon :color="check.valid ? 'green' : 'black'">{{
              check.valid ? "mdi-check-circle-outline" : "mdi-circle-small"
            }}</v-icon>
            <v-list-item-content
              class="pl-1"
              :class="check.valid ? 'text-color' : ''"
              >{{ check.text }}</v-list-item-content
            >
          </div>
        </v-list-item>
      </v-list>
      <v-card-text>
        <v-form ref="form" lazy-validation>
          <v-text-field
            v-model="authData.old_password"
            label="Old Password"
            prepend-icon="mdi-lock"
            :rules="[(v) => (v && !!v.trim()) || 'Old Password is required']"
            type="password"
            class="required"
            ref="old_password"
            @keyup.enter="validate()"
            @input="checkButtonDisabled"
          ></v-text-field>
          <v-text-field
            v-model="authData.new_password"
            label="New Password"
            prepend-icon="mdi-lock"
            :rules="[
              passwordRule,
              (v) => (v && !!v.trim()) || 'New password is required',
            ]"
            type="password"
            class="required"
            @input="checkButtonDisabled"
            @keyup.enter="validate()"
          ></v-text-field>
          <v-text-field
            v-model="confirm_password"
            label="Confirm New Password"
            prepend-icon="mdi-lock"
            :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
            :rules="[
              (v) => (v && !!v.trim()) || 'Confirm New Password is required',
              (v) =>
                v === authData.new_password ||
                'Password and Confirm password must match',
            ]"
            :type="showPass ? 'text' : 'password'"
            class="required"
            @click:append="showPass = !showPass"
            @keyup.enter="validate()"
            ref="confirm_password"
            @input="checkButtonDisabled"
          ></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <span class="text-error" v-if="showError"
          >Password Criteria is not satisfied!</span
        >
        <span class="text-success" v-if="!buttonHide && !showError"
          >Password Criteria is satisfied!</span
        >
        <v-btn
          class="mr-1"
          color="primary"
          :disabled="buttonHide || showError"
          @click="validate()"
          :loading="loader"
          >Change Password</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-col>
</template>
<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      authData: {
        old_password: null,
        new_password: "",
      },
      confirm_password: null,
      showPass: false,
      loader: false,
      passwordChecks: [
        {
          text: "Password should be atleast 8 characters",
          valid: false,
        },
        {
          text: "Password should contain atleast one uppercase.",
          valid: false,
        },
        {
          text: "Password should contain one of the special symbols !@#%",
          valid: false,
        },
      ],
      char: false,
      caps: false,
      specialChar: false,
      buttonHide: true,
      showError: false,
    };
  },
  computed: {
    passwordRule() {
      return (value) => {
        if (!value) {
          return false;
        } else {
          this.passwordChecks.forEach((check, index) => {
            switch (index) {
              case 0:
                check.valid = value.length >= 8;
                this.char = check.valid;
                break;
              case 1:
                check.valid = /[A-Z]/.test(value);
                this.caps = check.valid;
                break;
              case 2:
                check.valid = /^(?=.*[!@#%])[A-Za-z0-9!@#%]+$/.test(value);
                this.specialChar = check.valid;
                break;
              default:
                return;
            }
          });
          if (
            (!this.specialChar || !this.caps || !this.char) &&
            this.authData.new_password.length >= 8
          ) {
            this.showError = true;
          } else {
            this.showError = false;
          }
        }
        return;
      };
    },
  },
  methods: {
    ...mapActions(["changePassword", "snackBar"]),
    async checkButtonDisabled() {
      if (
        this.specialChar == true &&
        this.caps == true &&
        this.char == true &&
        this.$refs.confirm_password.validate() &&
        this.$refs.old_password.validate()
      ) {
        this.buttonHide = false;
      } else {
        this.buttonHide = true;
      }
    },
    validate() {
      this.loader = true;
      this.changePassword(this.authData)
        .then((res) => {
          this.loader = false;
          this.$refs.form.reset();
          this.snackBar({
            color: "success",
            message: res.data.message,
          });
        })
        .catch(() => {
          this.loader = false;
        });
    },
  },
};
</script>
<style>
.list-custom .v-list-item__content {
  font-size: 14px !important;
  padding-top: 4px;
  padding-bottom: 4px;
}
.list-custom .v-list-item {
  min-height: 22px !important;
}
.subheader {
  padding: 12px 10px 7px 23px;
  font-size: 14px;
}
.bg-color {
  display: flex;
  width: 100%;
  font-size: 14px;
}
.text-color {
  color: green;
}
.text-success {
  color: green;
  font-size: 12px;
  text-align: end;
}
.text-error {
  color: red;
  font-size: 12px;
  padding-left: 14px;
}
</style>
